import React from "react";

export const MailIcon = ({width=24, color="#000000"}) => (
    <svg 
        xmlns="http://www.w3.org/2000/svg" 
        width={width} 
        height={width} 
        viewBox="0 0 24 24" 
        fill="none" 
        stroke={color} 
        strokeWidth="1" 
        strokeLinecap="round" 
        strokeLinejoin="round">
    <path 
        d="M4 4h16c1.1 0 2 .9 2 2v12c0 1.1-.9 2-2 2H4c-1.1 0-2-.9-2-2V6c0-1.1.9-2 2-2z">
    </path>
    <polyline points="22,6 12,13 2,6"></polyline></svg>);

export default MailIcon;